import { render, staticRenderFns } from "./CoTwoMealForm.vue?vue&type=template&id=c699dd04&scoped=true&"
import script from "./CoTwoMealForm.vue?vue&type=script&lang=js&"
export * from "./CoTwoMealForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c699dd04",
  null
  
)

export default component.exports